import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70db79b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "addQuestionView" }
const _hoisted_2 = {
  key: 0,
  class: "bo"
}
const _hoisted_3 = {
  key: 1,
  class: "bo"
}

import MDEditor from "@/components/MDEditor.vue";
import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import { MyAxios } from "@/plugins/axios";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddQuestionView',
  setup(__props) {

const form = ref({
  answer: "",
  content: "",
  judgeCase: [
    {
      input: "",
      output: "",
    },
  ],
  judgeConfig: {
    memoryLimit: "",
    stackLimit: "",
    timeLimit: "",
  },
  tags: [],
  title: "",
});

const route = useRoute();
//如果地址包含update，视为更新页面
const updatePage = route.path.includes("update");

const loadData = () => {
  MyAxios.get("/question/get?id=" + route.query.id).then((res) => {
    if (res.data.code === 0) {
      form.value = res.data.data;
      if (form.value.tags) {
        form.value.tags = JSON.parse(form.value.tags as any);
      }
      if (!form.value.judgeCase) {
        form.value.judgeCase = [
          {
            input: "",
            output: "",
          },
        ];
      } else {
        form.value.judgeCase = JSON.parse(form.value.judgeCase as any);
      }
      if (!form.value.judgeConfig) {
        form.value.judgeConfig = {
          memoryLimit: "",
          timeLimit: "",
          stackLimit: "",
        };
      } else {
        form.value.judgeConfig = JSON.parse(form.value.judgeConfig as any);
      }
    } else {
      message.error("加载失败:" + res.data.message);
    }
  });
};
if (updatePage) {
  loadData();
}
/**
 * 修改题目
 */
const updateQuestion = () => {
  MyAxios.post("/question/update", form.value).then((res) => {
    if (res.data.code === 0) {
      message.success("修改题目成功！");
    } else {
      message.error("修改题目失败," + res.data.message);
    }
  });
};
/**
 * 创建题目
 */
const addQuestion = () => {
  // const res = QuestionControllerService.addQuestionUsingPost(data.values);
  MyAxios.post("/question/add", form.value).then((res) => {
    if (res.data.code === 0) {
      message.success("创建题目成功！");
    } else {
      message.error("创建题目失败," + res.data.message);
    }
  });
};
/**
 * 提交
 */
const handleSubmit = () => {
  if (updatePage) {
    updateQuestion();
  } else {
    addQuestion();
  }
};
const handleDelete = (index: any) => {
  form.value.judgeCase.splice(index, 1);
};
const handleAdd = () => {
  form.value.judgeCase.push({
    input: "",
    output: "",
  });
};
const handleAnswerChange = (v: string) => {
  form.value.answer = v;
};
const handleContentChange = (v: string) => {
  form.value.content = v;
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(updatePage))
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "修改题目"))
      : (_openBlock(), _createElementBlock("h2", _hoisted_3, "创建题目")),
    _createVNode(_component_a_form, {
      class: "card",
      model: form.value,
      "label-align": "left"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "题目标题"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              style: {"max-width":"480px"},
              modelValue: form.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
              placeholder: "请输入题目标题"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "tags",
          label: "题目标签"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: form.value.tags,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.tags) = $event)),
              style: {"max-width":"480px"},
              placeholder: "请输入标签(回车确认)",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "判题配置",
          "content-flex": false,
          "merge-props": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, {
              direction: "vertical",
              style: {"min-width":"480px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "内存限制" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      mode: "button",
                      min: "0",
                      modelValue: form.value.judgeConfig.memoryLimit,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.judgeConfig.memoryLimit) = $event)),
                      placeholder: "请输入内存限制(kb)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "时间限制" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      min: "0",
                      mode: "button",
                      modelValue: form.value.judgeConfig.timeLimit,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.judgeConfig.timeLimit) = $event)),
                      placeholder: "请输入时间限制(ms)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "堆栈限制" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      min: "0",
                      mode: "button",
                      modelValue: form.value.judgeConfig.stackLimit,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.judgeConfig.stackLimit) = $event)),
                      placeholder: "请输入堆栈限制(kb)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.judgeCase, (judgeCase, index) => {
          return (_openBlock(), _createBlock(_component_a_form_item, {
            field: `judgeCase[${index}]`,
            label: `用例 ${index + 1}`,
            key: index
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, {
                direction: "vertical",
                style: {"min-width":"480px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "用例输入" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        modelValue: judgeCase.input,
                        "onUpdate:modelValue": ($event: any) => ((judgeCase.input) = $event),
                        placeholder: "输入"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_form_item, { label: "用例输出" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        modelValue: judgeCase.output,
                        "onUpdate:modelValue": ($event: any) => ((judgeCase.output) = $event),
                        placeholder: "输出"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_button, {
                status: "danger",
                onClick: ($event: any) => (handleDelete(index)),
                style: { marginLeft: '10px' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1032, ["field", "label"]))
        }), 128)),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              status: "success",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (handleAdd()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加用例")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "content",
          label: "题目内容"
        }, {
          default: _withCtx(() => [
            _createVNode(MDEditor, {
              value: form.value.content,
              onChange: handleContentChange
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "answer",
          label: "标准答案"
        }, {
          default: _withCtx(() => [
            _createVNode(MDEditor, {
              value: form.value.answer,
              onChange: handleAnswerChange
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: handleSubmit,
              type: "primary",
              "html-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})